<template>
  <HeroLoading :linkTo="{ name: 'campaignList' }" :textLinkTo="$t('campaign.loading.textLink')" :status="campaignStatus">
    <div slot="contentLoading" class="text-center">
      {{ $t('campaign.loading.text1') }}
    </div>

    <div slot="content" class="text-center">
      {{ $t('campaign.loading.text2') }}
    </div>

    <div slot="insights">
      <CIcon name="insights" size="custom-size" :height="42" viewBox="0 0 32 32"> </CIcon>
      <p class="mb-0 text-gray-600">{{ $t(`general.${smartInsights.title}`) }}</p>
      <p class="text-black mt-2 mb-2 h3 font-weight-normal">
        {{ $t(`general.${smartInsights.subtitle}`) }}
      </p>
      <p class="text-gray-600 text-left">
        {{ $t(`general.${smartInsights.description}`) }}
      </p>
    </div>
  </HeroLoading>
</template>

<script>
import HeroLoading from '@/components/HeroLoading'
import services from '@/services.js'
const campaignStatus = {
  1: 'Draft',
  2: 'Calculating',
  3: 'Ready-to-Send',
  4: 'Sent',
  5: 'On-going',
  6: 'Scheduled',
  7: 'Deleted',
}
export default {
  name: 'loading',

  components: {
    HeroLoading,
  },

  data() {
    return {
      campaignId: null,
      loading: false,
      intervalTime: null,
      campaignStatus: false,
      smartInsights: {
        title: null,
        subtitle: null,
        description: null,
        icon: null,
      },
      webAreaId: 1,
    }
  },

  created() {
    this.campaignId = this.$route.params.campaignId
    this.getSmartInsight()
  },

  beforeDestroy() {
    clearInterval(this.intervalTime)
  },

  mounted() {
    this.getData(this.campaignId)
  },

  methods: {
    getCampaign(id) {
      this.loading = true
      let organizationId = this.$store.state.auth.organizationId

      services
        .getCampaign(organizationId, id)
        .then(({ data }) => {
          if (data.data.campaignStatus == 3) {
            this.$router.push({ name: 'campaignSummary', params: { campaignId: this.$route.params.campaignId } })
          }
        })
        .catch(({ response }) => {
          if (response) {
            this.messages.push({
              status: 'danger',
              text: response.data.Message || response.data.data.Message || 'Erro',
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    getSmartInsight() {
      let organizationId = this.$store.state.auth.organizationId
      services
        .getSmartInsight(organizationId, this.webAreaId)
        .then((res) => {
          this.smartInsights.title = res.data.data.smartInsight.title
          this.smartInsights.subtitle = res.data.data.smartInsight.subtitle
          this.smartInsights.description = res.data.data.smartInsight.description
          // this.smartInsights.icon = res.data.data.smartInsight.icon
        })
        .finally(() => {
          this.loading = false
        })
    },

    isReadToSend(enm) {
      return 'Ready-to-Send' == campaignStatus(enm)
    },

    getData(id) {
      this.intervalTime = setInterval(() => {
        if (!this.loading) this.getCampaign(id)
      }, this.$configs.VUE_APP_TIME_TABLE || 10000)
    },
  },
}
</script>

<style></style>
